import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const WhyChoose = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div>
        <div>
          <p className="lg:text-5xl text-nowrap text-[16px] text-black font-semibold text-center">
            Why Choose Visual Folio?
          </p>
          <div>
            <div className="bg-glass-why-choose relative">
              <div className="container mx-auto pt-16">
                <div className="flex">
                  <div className="w-1/5 pt-[3%] hover:transform hover:scale-110 transition duration-100 ease-in">
                    {theme == "glassy" ? (
                      <StaticImage
                        src="./success-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme === "light" ? (
                      <StaticImage
                        src="./success-light.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme == "dark" ? (
                      <StaticImage
                        src="./success-dark.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : (
                      <StaticImage
                        src="./success-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    )}
                  </div>
                  <div className="w-1/5 pt-[7%] hover:transform hover:scale-110 transition duration-100 ease-in">
                    {theme == "glassy" ? (
                      <StaticImage
                        src="./growth-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme === "light" ? (
                      <StaticImage
                        src="./growth-light.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme == "dark" ? (
                      <StaticImage
                        src="./growth-dark.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : (
                      <StaticImage
                        src="./growth-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    )}
                  </div>
                  <div className="w-1/5 pt-[12%] hover:transform hover:scale-110 transition duration-100 ease-in">
                    {theme == "glassy" ? (
                      <StaticImage
                        src="./loyality-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme === "light" ? (
                      <StaticImage
                        src="./loyality-light.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme == "dark" ? (
                      <StaticImage
                        src="./loyality-dark.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : (
                      <StaticImage
                        src="./loyality-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    )}
                  </div>
                  <div className="w-1/5 pt-[17%] hover:transform hover:scale-110 transition duration-100 ease-in">
                    {theme == "glassy" ? (
                      <StaticImage
                        src="./transparency-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme === "light" ? (
                      <StaticImage
                        src="./transparency-light.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme == "dark" ? (
                      <StaticImage
                        src="./transparency-dark.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : (
                      <StaticImage
                        src="./transparency-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    )}
                  </div>
                  <div className="w-1/5 pt-[20%] hover:transform hover:scale-110 transition duration-100 ease-in">
                    {theme == "glassy" ? (
                      <StaticImage
                        src="./connect-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme === "light" ? (
                      <StaticImage
                        src="./connect-light.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : theme == "dark" ? (
                      <StaticImage
                        src="./connect-dark.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    ) : (
                      <StaticImage
                        src="./connect-glass.png"
                        alt="success"
                        placeholder="blurred"
                        layout="fullWidth"
                      />
                    )}
                  </div>
                </div>
                <div className="w-[70%] container mx-auto pt-10 z-[-10] absolute bottom-[-10%] rotate-[-4deg] left-[8%]">
                  <StaticImage
                    src="./lines-glass.png"
                    alt="success"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
